/**
 * User Role Constants
 * Centralized role definitions to prevent authorization bypass vulnerabilities
 */

// Role constants
export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_USER = 'ROLE_USER';
export const ROLE_VIEWER = 'ROLE_VIEWER';

// Normalized role values (without ROLE_ prefix)
export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const VIEWER = 'VIEWER';

// Valid admin role values
export const ADMIN_ROLES = [ROLE_ADMIN, ADMIN, 'Admin'];

// Valid viewer role values
export const VIEWER_ROLES = [ROLE_VIEWER, VIEWER, 'Viewer', 'VIEWER'];

// Valid user role values
export const USER_ROLES = [ROLE_USER, USER, 'User', 'USER'];

/**
 * Check if a role is an admin role
 * @param {string} role - The role to check
 * @returns {boolean} - True if the role is an admin role
 */
export const isAdmin = (role) => {
  if (!role) return false;
  return ADMIN_ROLES.includes(role);
};

/**
 * Check if a role is a viewer role
 * @param {string} role - The role to check
 * @returns {boolean} - True if the role is a viewer role
 */
export const isViewer = (role) => {
  if (!role) return false;
  return VIEWER_ROLES.includes(role);
};

/**
 * Check if a role is a regular user role
 * @param {string} role - The role to check
 * @returns {boolean} - True if the role is a user role
 */
export const isUser = (role) => {
  if (!role) return false;
  return USER_ROLES.includes(role);
};

/**
 * Get normalized role name (without ROLE_ prefix)
 * @param {string} role - The role to normalize
 * @returns {string} - Normalized role name
 */
export const normalizeRole = (role) => {
  if (!role) return '';
  return role.replace('ROLE_', '');
};
